import { render } from "./TheLocaleList.vue?vue&type=template&id=81cea19e&scoped=true"
import script from "./TheLocaleList.vue?vue&type=script&lang=js"
export * from "./TheLocaleList.vue?vue&type=script&lang=js"

import "./TheLocaleList.vue?vue&type=style&index=0&id=81cea19e&lang=scss&scoped=true"

import exportComponent from "/local/p4clients/pkgbuild-const/workspace/src/VendorCentralTrimWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81cea19e"]])

export default __exports__